// Generated by CoffeeScript 1.9.2
var helpers;

helpers = require('../helpers');

module.exports = {
  params: {
    options: function(exe, params) {
      return helpers.unary(exe, params, function(source) {
        return source;
      });
    },
    pluck: function(exe, params) {
      return helpers.params(exe, params, function(params, source) {
        var plu;
        plu = function(d) {
          return d[params];
        };
        if (source instanceof Array) {
          return source.map(plu);
        } else {
          return plu(source);
        }
      });
    },
    remove: function(exe, params) {
      return helpers.params(exe, params, function(params, source) {
        var rem;
        rem = function(d) {
          var _, target;
          for (target in params) {
            _ = params[target];
            delete d[target];
          }
          return d;
        };
        if (source instanceof Array) {
          return source.map(rem);
        } else {
          return rem(source);
        }
      });
    },
    shape: function(exe, params) {
      return helpers.params(exe, params, function(params, source) {
        var sha;
        sha = function(d) {
          var _, res, target;
          res = {};
          for (target in params) {
            _ = params[target];
            res[target] = d[target];
          }
          return res;
        };
        if (source instanceof Array) {
          return source.map(sha);
        } else {
          return sha(source);
        }
      });
    },
    rename: function(exe, params) {
      return helpers.params(exe, params, function(params, source) {
        var trans;
        trans = function(d) {
          var target, value;
          for (target in params) {
            source = params[target];
            value = d[source];
            delete d[source];
            d[target] = value;
          }
          return d;
        };
        if (source instanceof Array) {
          return source.map(trans);
        } else {
          return trans(source);
        }
      });
    }
  },
  unary: {
    ref: function(exe, params) {
      throw new Error('References should not be executed');
    },
    count: function(exe, params) {
      return helpers.unary(exe, params, function(source) {
        if (!(source instanceof Array)) {
          throw new Error('Not an array');
        }
        return source.length;
      });
    },
    one: function(exe, params) {
      return helpers.unary(exe, params, function(source) {
        if (!(source instanceof Array)) {
          throw new Error('Not an array');
        }
        if (source.length !== 1) {
          throw new Error('No single item');
        }
        return source.pop();
      });
    },
    oneornone: function(exe, params) {
      return helpers.unary(exe, params, function(source) {
        if (!(source instanceof Array)) {
          throw new Error('Not an array');
        }
        if (source.length === 0) {
          return null;
        }
        if (source.length === 1) {
          return source.pop();
        }
        throw new Error('More than one item');
      });
    }
  }
};
